module.exports = __webpack_public_path__ + "img/slide-4.eaf277d4.jpg";